import React, { useState } from "react";
import styles from "../Home/StudentWork/StudentWork.module.scss";
import ReactPlayer from "react-player";
import { Icon } from "../../assets/Icons.tsx";
import Modal from "react-bootstrap/Modal";

interface Section {
  title: string;
  mainImage: string;
  corner1: string;
  corner2: string;
  video?: string;
  id?: number;
  thumbnail?: string;
}

interface CardComponentProps {
  section?: Section;
  sections?: Section[];
  topPadding?: string;
  playingVideoId?: number | null;
  onPlay?: (id: number) => void;
  showTitle: boolean;
}

const StudentWorkCard: React.FC<CardComponentProps> = ({
  section,
  sections,
  topPadding,
  playingVideoId,
  onPlay,
  showTitle,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSections, setSelectedSections] = useState<Section[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const openModal = (sectionTitle: string) => {
    const filteredSections =
      sections?.filter((item) => item.title === sectionTitle) || [];

    if (filteredSections.length > 0 && showTitle) {
      setSelectedSections(filteredSections);
      setCurrentIndex(0);
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedSections([]);
    setCurrentIndex(0);
  };

  const handleNext = () => {
    if (currentIndex < selectedSections.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="col-lg-4 col-md-6 col-sm-12 p-1">
      <div className={`${styles.imageWrapper} position-relative`}>
        {showTitle && (
          <div className={styles.titleBox}>
            <div className={`${styles.btnBlack}`}>{section?.title}</div>
          </div>
        )}
        {section?.mainImage && (
          <img
            src={section.mainImage}
            alt={`${section.title} Main`}
            className={styles.mainImage}
            onClick={() => openModal(section.title)}
          />
        )}
        <img
          src={section?.corner1}
          className={`position-absolute ${styles.rotatingImage}`}
          alt={`${section?.title} Top Right`}
          style={{ top: topPadding }}
        />
        {section?.video && (
          <div className="position-relative" style={{ height: "85%" }}>
            <div className={styles.playerWrapper}>
              {playingVideoId !== section.id && (
                <div
                  className={styles.thumbnail}
                  style={{ backgroundImage: `url(${section.thumbnail})` }}
                  onClick={() => openModal(section.title)}
                ></div>
              )}
              {playingVideoId === section.id && (
                <ReactPlayer
                  url={section.video}
                  playing={true}
                  controls={true}
                  width="100%"
                  height="100%"
                  className={styles.reactPlayer}
                />
              )}
              {playingVideoId !== section.id && (
                <div className={styles.playButtonDiv}>
                  <div
                    onClick={() => onPlay(section?.id)}
                    style={{ zIndex: 2 }}
                  >
                    <Icon
                      name="animationVideoPlayIcon"
                      height="50px"
                      width="50px"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <img
          src={section.corner2}
          className={`position-absolute ${styles.rotatingImage1}`}
          alt={`${section.title} Bottom Left`}
        />
      </div>
      {modalOpen && selectedSections.length > 0 && (
        <Modal
          show={modalOpen}
          onHide={closeModal}
          dialogClassName={styles.customModal}
          aria-labelledby="example-custom-modal-styling-title"
          centered
        >
          <Modal.Header
            style={{ padding: "15px 15px 0px 15px", borderBottom: "none" }}
          >
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
              style={{
                fontSize: "1.5rem", // Adjust size of the icon
                width: "2rem", // Adjust width
                height: "2rem", // Adjust height
              }}
            ></button>
          </Modal.Header>
          <Modal.Body>
            {selectedSections[currentIndex]?.title && (
              <div className={styles.titleBoxModal}>
                <div className={`${styles.btnBlack}`}>
                  {selectedSections[currentIndex].title}
                </div>
              </div>
            )}
            <div className="mb-5">
              <div className="position-relative d-flex justify-content-around align-items-center w-100">
                <div
                  onClick={handlePrevious}
                  className={`d-flex justify-content-center ${styles.IconWrapper}`}
                  // style={{ cursor: "pointer", width: "150px" }}
                >
                  {(selectedSections.length > 1 && currentIndex !==0 ) && (
                    <Icon name="backArrowIcon" height="50px" width="50px" />
                  )}
                </div>
                <div
                  className={`${styles.imageWrapperModal} position-relative p-4 m-3`}
                >
                  {selectedSections[currentIndex]?.mainImage && (
                    <img
                      src={selectedSections[currentIndex].mainImage}
                      alt={`${selectedSections[currentIndex].title} Main`}
                      className={styles.mainImage}
                    />
                  )}
                  <img
                    src={selectedSections[currentIndex]?.corner1}
                    className={`position-absolute ${styles.rotatingImageModal}`}
                    alt={`${selectedSections[currentIndex]?.title} Top Right`}
                    style={{ top: topPadding }}
                  />
                  {selectedSections[currentIndex]?.video && (
                    <div
                      className="position-relative"
                      style={{ height: "85%" }}
                    >
                      <div className={styles.playerWrapper}>
                        {playingVideoId !==
                          selectedSections[currentIndex]?.id && (
                          <div
                            className={styles.thumbnail}
                            style={{
                              backgroundImage: `url(${selectedSections[currentIndex].thumbnail})`,
                            }}
                          ></div>
                        )}
                        {playingVideoId ===
                          selectedSections[currentIndex]?.id && (
                          <ReactPlayer
                            url={selectedSections[currentIndex]?.video}
                            playing={true}
                            controls={true}
                            width="100%"
                            height="100%"
                            className={styles.reactPlayer}
                          />
                        )}
                        {playingVideoId !==
                          selectedSections[currentIndex]?.id && (
                          <div className={styles.playButtonDiv}>
                            <div
                              onClick={() =>
                                onPlay(selectedSections[currentIndex]?.id)
                              }
                              style={{ zIndex: 2 }}
                            >
                              <Icon
                                name="animationVideoPlayIcon"
                                height="50px"
                                width="50px"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <img
                    src={selectedSections[currentIndex]?.corner2}
                    className={`position-absolute ${styles.rotatingImage1Modal}`}
                    alt={`${selectedSections[currentIndex]?.title} Bottom Left`}
                  />
                </div>
                <div
                  onClick={handleNext}
                  className={`d-flex justify-content-center ${styles.IconWrapper}`}
                  // style={{ cursor: "pointer", width: "150px" }}
                >
                  {(selectedSections.length > 1 && selectedSections.length-1 !== currentIndex) && (
                    <Icon name="forwardArrowIcon" height="50px" width="50px" />
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default StudentWorkCard;
